import React, { FC, useMemo } from 'react';

const DOT_COUNT = 1000;
const DOT_STRING = ' .'.repeat(DOT_COUNT);

const FormDots = ({ style }) => {
	return (
		<div
			style={{
				overflow: 'hidden',
				display: 'inline-block',
				flex: '0 1 auto',
			}}
		>
			<div
				style={{
					display: 'block',
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'clip',
					...style,
				}}
			>
				{DOT_STRING}
			</div>
		</div>
	);
};

export const DotSeparator = () => {
	return (
		<div
			style={{
				flexGrow: 1,
				borderBottom: '2px dotted rgba(0, 0, 0, 0.45)',
				marginTop: '0.5em',
			}}
		/>
	);
};
export default FormDots;
